import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import Breadcrumb from '../../components/breadcrumbs/Breadcrumb';

import PixelsTokensTable from '../../components/facebook/pixelsTokens/PixelsTokensTable';

function PixelsTokens() {

  return (
    <div className="uk-container">

      <div data-uk-grid>

        <div className="uk-width-3-4">
          <Breadcrumbs>
            <Breadcrumb><NavLink to="/">Панель администратора</NavLink></Breadcrumb>
            <Breadcrumb><span>Facebook пиксели/токены</span></Breadcrumb>
          </Breadcrumbs>
        </div>

      </div>

      <h1 className="uk-heading-line uk-text-center">
        <span>Facebook пиксели/токены</span>
      </h1>

      <h1 className="uk-heading-divider"></h1>

      <PixelsTokensTable />

    </div>
  )
}

export default PixelsTokens;
